import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExampleBarWidgetComponent } from './example-bar-widget.component';
import {DxChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [ExampleBarWidgetComponent],
    imports: [
        CommonModule,
        DxChartModule
    ],
  exports: [ExampleBarWidgetComponent]
})
export class ExampleBarWidgetModule { }
